import { IcNeutralTarget } from '@assets/icons/32x32';
import { Box, Icon } from '@chakra-ui/react';
import { useAppSelector } from '@hooks/redux.hooks';
import { useSelectorWithMapId } from '@hooks/useSelectorWithMapId';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { useWithDispatch } from '@hooks/useWithDispatch';
import { hasSensorRoleFromActiveProfile } from '@redux/authent/authent.selectors';
import { updatePopupByMapId } from '@redux/maps/maps.reducer';
import { selectPopupsByMapId } from '@redux/maps/maps.selectors';
import { selectIsNeutralSensorJamming } from '@redux/situation/monitoring.selectors';
import { selectIsEngagementOnGoing, selectSituationTime } from '@redux/situation/situation.selectors';
import { isOpenedPopupByType } from '@utils/popup.utils';

import { ActionEnum } from '@/types/commons/commons.types';
import { MapIdEnum } from '@/types/map.types';
import { PopupTypeEnum } from '@/types/popup.types';
import { SensorFamilyEnum } from '@/types/sensor/sensor.types';

import { useMapContext } from '../MapContext';

export default function MapTitleNeutral() {
  const { mapId } = useMapContext();
  const situationTime = useSelectorWithReplayMode(selectSituationTime);
  const popups = useSelectorWithMapId(selectPopupsByMapId);
  const updatePopup = useWithDispatch(updatePopupByMapId);
  const neutralSensorActionCommand = { action: ActionEnum.COMMAND, sensorFamily: SensorFamilyEnum.NEUTRAL };
  const accessNeutralCommand = useAppSelector((state) =>
    hasSensorRoleFromActiveProfile(state, neutralSensorActionCommand),
  );
  const neutralSensorActionAccess = { action: ActionEnum.ACCESS, sensorFamily: SensorFamilyEnum.NEUTRAL };
  const accessNeutral = useAppSelector((state) => hasSensorRoleFromActiveProfile(state, neutralSensorActionAccess));
  const isEngagementOngoing = useSelectorWithReplayMode(selectIsEngagementOnGoing);
  const isJammingOngoing = useSelectorWithReplayMode(selectIsNeutralSensorJamming);

  if (!accessNeutral || (!isEngagementOngoing && !isJammingOngoing)) {
    return null;
  }

  function handleOpenPopup() {
    updatePopup({
      mapId,
      popup: {
        type: PopupTypeEnum.ENGAGEMENT,
        position: { x: 500, y: 150 },
        data: {
          openingDate: situationTime ? new Date(situationTime) : new Date(),
        },
      },
    });
  }

  const canOpenPopup =
    mapId !== MapIdEnum.REPLAY && accessNeutralCommand && !isOpenedPopupByType(popups, PopupTypeEnum.ENGAGEMENT);

  if (isJammingOngoing) {
    return (
      <Box
        width="32px"
        height="32px"
        backgroundColor="red.900"
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundImage="url(/jamming-icon.gif)"
        cursor={canOpenPopup ? 'pointer' : 'default'}
        onClick={() => canOpenPopup && handleOpenPopup()}
      />
    );
  }

  if (isEngagementOngoing) {
    return (
      <Icon
        as={IcNeutralTarget}
        width="32px"
        height="32px"
        cursor={canOpenPopup ? 'pointer' : 'default'}
        onClick={() => canOpenPopup && handleOpenPopup()}
      />
    );
  }
}
